import { render, staticRenderFns } from "./ItemContact.vue?vue&type=template&id=eb797444"
import script from "./ItemContact.vue?vue&type=script&lang=js"
export * from "./ItemContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports